import React, { Component } from 'react'
import { PropTypes } from 'prop-types'

import './BurgerMenu.scss'

export default class LandingPage extends Component {

  static propTypes = {
    curMenuState: PropTypes.bool,
    onMenuChange: PropTypes.func
  }

  constructor(props) {
    super(props);
    this._onBurgerClick = this._onBurgerClick.bind(this);
  }

  _onBurgerClick(evt) {
    this.props.onMenuChange && this.props.onMenuChange(evt, !this.props.curMenuState)
  }

  render() {
    return <a className={`burger-menu ${this.props.className}`} onClick={this._onBurgerClick}></a>
  }
}



// WEBPACK FOOTER //
// ./component/ui/Button/BurgerMenu.js